import { StyledIconButton } from './styles'

export function IconButton({ color = 'gray', size = 'md', ...props }) {
  return <StyledIconButton color={color} size={size} {...props} />
}
